var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Subject } from '@/models/Subject';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let AreaSelect = class AreaSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.defaultFilters = {
            depth: 0,
        };
        this.areas = [];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    initialize() {
        this.fetchAreas();
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods
    async fetchAreas() {
        this.areas = await new Subject()
            .include(this.includes || [])
            .filter(this.mergedFilters)
            .all();
    }
    // #endregion
    // #region Getters & Setters
    get mergedFilters() {
        return this.filters
            ? { ...this.filters, ...this.defaultFilters }
            : this.defaultFilters;
    }
    // #endregion
    // #region @Watchers
    onPropChange(newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        this.fetchAreas();
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", Array)
], AreaSelect.prototype, "includes", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], AreaSelect.prototype, "filters", void 0);
__decorate([
    Watch('includes', { immediate: true, deep: true }),
    Watch('filters', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AreaSelect.prototype, "onPropChange", null);
AreaSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], AreaSelect);
export default AreaSelect;
